import { Modal, ModalWidth } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { useGlobalModalContext } from '../index';
import styles from './GenericModal.module.scss';

const cx = classNames.bind(styles);

export interface GenericModalProps {
  headerTitle: string;
  content: string;
  dataTestId?: string;
}

const GenericModal = ({ headerTitle, content, dataTestId }: GenericModalProps): ReactElement => {
  const { closeModal } = useGlobalModalContext();

  return (
    <Modal width={ModalWidth.Medium} open onClose={closeModal} headerTitle={headerTitle}>
      <div className={cx('body')} data-testid={dataTestId} dangerouslySetInnerHTML={{ __html: content }} />
    </Modal>
  );
};

export default GenericModal;
